import React, {useState} from "react";
import { useRouter } from 'next/router';
import { authlogin } from '../../lib/api/auth';
import Loader from '../../components/loader';
import { notifyMe } from "../../helper";
import { Popconfirm, message } from 'antd';
import Link from "next/link";
import withAuthHOC from "../../lib/withAuthHOC";

const CartNavigation = ({step, user}) => {
  const router = useRouter();


  return (
    <>
    <div className="container main-container mt-60 cart-nav">
        <div className="nav-2-wrapper">
            <ul>
                <li className={step == 'step1' ?  "active_4" : ''}>
                  <div className="number_tag">
                      <p>CESTA</p>
                      {step == 'step2' || step == 'step3' || step == 'step4' || step == 'step5'
                      ? <Link href="/checkout" passHref={true}><h2 className="goback">1</h2></Link>
                      : <h2>1</h2>
                      }
                      {step == 'step1' ?  <i className="arrow_down"></i> : ''}
                  </div>
                  <hr className="line7" />
                </li>
                <li className={step == 'step2' ?  "active_4" : ''}>
                  <div className="top-nav-2">
                      <div className="number_tag">
                          <span>INICIO DE SESIÓN</span>
                          <p>&nbsp;</p>
                          {(step == 'step3' || step == 'step4' || step == 'step5') && !user
                          ? <Link href="/checkout/step2" passHref={true}><h2 className="goback">2</h2></Link>
                          : <h2>2</h2>
                          }
                          {step == 'step2' ?  <i className="arrow_down"></i> : ''}
                      </div>
                    </div>
                    <hr className="line7" />
                </li>
              <li className={step == 'step3' ?  "active_4" : ''}>
                  <div className="top-nav-2">
                      <div className="number_tag">
                          <p>ENVÍO</p>
                          {step == 'step4' || step == 'step5'
                          ? <Link href="/checkout/step3" passHref={true}><h2 className="goback">3</h2></Link>
                          : <h2>3</h2>
                          }
                          {step == 'step3' ?  <i className="arrow_down"></i> : ''}
                      </div>
                  </div>
                  <hr className="line7" />
                </li>
                  <li className={step == 'step4' ?  "active_4" : ''}>
                    <div className="number_tag">
                        <span>FACTURACIÓN</span>
                        <p>&nbsp;</p>
                        {step == 'step5'
                        ? <Link href="/checkout/step4" passHref={true}><h2 className="goback">4</h2></Link>
                        : <h2>4</h2>
                        }
                        {step == 'step4'  ?  <i className="arrow_down"></i> : ''}

                    </div>
                    <hr className="line7" />
                </li>
                <li className={step == 'step5' ?  "active_4" : ''}>
                  <div className="top-nav-2">
                      <div className="number_tag">
                          <p>PAGO</p>
                          <h2>5</h2>
                          {step == 'step5' ?  <i className="arrow_down"></i> : ''}
                      </div>
                  </div>
                  <hr className="line7" />
                </li>
                <li className={step == 'step6' ?  "active_4" : ''}>
                  <div className="top-nav-2">
                      <div className="number_tag">
                          <p>HECHO!</p>
                          <h2>6</h2>
                          {step == 'step6' ?  <i className="arrow_down"></i> : ''}
                      </div>
                  </div>
                </li>
            </ul>
        </div>
    </div>

    <div className="clearfix"></div>
    </>
    )
}

export default withAuthHOC(CartNavigation);
